import 'remixicon/fonts/remixicon.css';
import OrganizeResultItem from './OrganizeResultItem';
import FindErrorResultItem from './FindErrorResultItem';
import ResultHeaders from './ResultHeaders';
import { AnswerSetResult } from '../../../../store/viewmodels/AnswerSetViewModel';
import { getClockTime, getDurationInSeconds, getMins, getSeconds, getDate } from '../../../utils/DateServices';
import VideoRecordingResultItem from './VideoRecordingResultItem';
import { useAppSelector } from '../../../../store/Hooks';
import { Task } from '../../../../store/viewmodels/TaskViewModel';
import OneChoiceResultItem from './OneChoiceResultItem';
import MemoryGameResultItem from './MemoryGameResultItem';
import CombineResultItem from './CombineResultItem';
import { Student } from '../../../../store/viewmodels/StudentViewModel';
import VideoInstructionResultItem from './VideoInstructionResultItem';

interface AnswerSetResultsProps {
    answerSet: AnswerSetResult,
    student: Student,
}

function AnswerSetResults(props: AnswerSetResultsProps): JSX.Element {

    const endDate = new Date(Date.parse(props.answerSet.end_time));
    const date = getDate(endDate);
    const clockTime = getClockTime(endDate);
    const answersCount = props.answerSet.answers.length;

    const startDate = new Date(Date.parse(props.answerSet.start_time));
    const durationSeconds = getDurationInSeconds(endDate, startDate);
    const mins: number = getMins(durationSeconds);
    const secs: number = getSeconds(durationSeconds);

    const headerElement = (
        <div className="grid pb-4" key={"answerSetHeader_" + props.answerSet.id}>
            <div className="grid grid-cols-4 gap-x-6 gap-y-2 text-center" key={"answerSetHeaderDiv_" + props.answerSet.id}>
                <label className="text-xl text-teal-500" key={"answerSetHeader_dateLabel" + props.answerSet.id}>Päivä</label>
                <label className="text-xl text-teal-500" key={"answerSetHeader_klo" + props.answerSet.id}>Klo</label>
                <label className="text-xl text-teal-500" key={"answerSetHeader_answers" + props.answerSet.id}>Vastatut</label>
                <label className="text-xl text-teal-500" key={"answerSetHeader_time" + props.answerSet.id}>Aika</label>
                <label className="text-xl font-bold text-gray-500" key={"answerSetHeader_date" + props.answerSet.id} >{date}</label>
                <label className="text-xl font-bold text-gray-500" key={"answerSetHeader_kloklo" + props.answerSet.id}>{clockTime}</label>
                <label className="text-xl font-bold text-gray-500" key={"answerSetHeader_answercount" + props.answerSet.id}>{answersCount}</label>
                <label className="text-xl font-bold text-gray-500" key={"answerSetHeader_duration" + props.answerSet.id}>{mins + " min " + Math.round(secs) + " s"}</label>
            </div>
        </div>
    );

    let resultItems = [];
    let currentType = "";
    let previousType = "";

    let taskType = SearchTaskType(props.answerSet.itemset.id);
    let itemsetType = props.answerSet.itemset.type !== "NONE" ? props.answerSet.itemset.type : taskType;

    for (let i: number = 0; i < props.answerSet.answers.length; i++) {
        let answerItem = props.answerSet.answers[i];

        currentType = answerItem.item?.type !== "NONE" ? answerItem.item?.type : itemsetType;

        if (currentType === "NONE") {
            currentType = previousType;
        }
        else if (currentType !== previousType) {
            let resultHeaderRow = <ResultHeaders type={currentType} key={"resultHeader" + itemsetType + answerItem.id} />;
            resultItems.push(resultHeaderRow);
        }

        let resultRow: JSX.Element = <div key={"empty" + answerItem.id}></div>;

        switch (currentType?.toUpperCase()) {
            case "NONE": {
                break;
            }
            case "FIND-ERROR" : {
                resultRow = <FindErrorResultItem key={"find-error_result" + answerItem.id} answer={answerItem} />;
                break;    
            }
            case "ORGANIZE" : {
                resultRow = <OrganizeResultItem key={"organize_result" + answerItem.id} answer={answerItem} />;
                break;
            }
            case "VIDEO-RECORDING": {
                resultRow = <VideoRecordingResultItem key={"videorecording_result" + answerItem.id} answerSet={props.answerSet} answer={answerItem} student={props.student} />;
                break;
            }
            case "ONE-CHOICE": {
                resultRow = <OneChoiceResultItem key={"onechoice_result" + answerItem.id} answer={answerItem} />;
                break;
            }
            case "COMBINE": {
                resultRow = <CombineResultItem key={"combine_result" + answerItem.id} answer={answerItem} />;
                break;
            }
            case "VIDEO-INSTRUCTION" : {
                resultRow = <VideoInstructionResultItem key={"videoInstructionResultItem" + answerItem.id} answer= {answerItem} />
                break;
            }
            case "MEMORY-GAME": {
                resultRow = <MemoryGameResultItem key={"memorygame_result" + answerItem.id} answer={answerItem} />;
                break;
            }
            default: {
                break;
            }
        }
        
        resultItems.push(resultRow);
        previousType = currentType;
    }

    return (
        <div className="mt-4" key={"answerSetResultHeader_" + props.answerSet.id}>
            {headerElement}
            <div className="mt-4" key={"answerSetResultAnswers_" + props.answerSet.id}>
                <div className="mt-4" key={"answerSetResultItems_" + props.answerSet.id}>
                    {resultItems}
                </div>
            </div>
        </div>
    );
}

function SearchTaskType(itemsetId: number): string {
    const teacherData = useAppSelector(state => state.teacherData);
    const licences = teacherData.teacher.licences;
    let allTasks: Task[] = [] as Task[];

    for (let l: number = 0; l < licences.length; l++) {
        allTasks.concat(licences[l].tasks);
    }

    for (let t: number = 0; allTasks.length; t++) {
        let task = allTasks[t];

        for (let i: number = 0; i < task.itemsets.length; i++) {
            let itemset = task.itemsets[i];
            if (itemset.id === itemsetId) return task.type;
        }
    }

    return "NONE";
}

export default AnswerSetResults;